export enum DRAWERS {
  ACCOUNT_DETAILS = 'account-drawer',
  JOURNAL_DETAILS = 'journal-drawer',
  EXPENSE_DETAILS = 'expense-drawer',
  NOTE_DE_FRAIS_DETAILS = 'note-de-frais-detail-drawer',
  CHEQUE_RECU_DETAILS = 'cheque-recu-detail-drawer',
  CASH_MOVEMENT_DETAILS = 'cash-movement-detail-drawer',
  BILL_DETAILS = 'bill-drawer',
  INVOICE_DETAILS = 'invoice-detail-drawer',
  RECEIPT_DETAILS = 'receipt-detail-drawer',
  PAYMENT_RECEIVED_DETAILS = 'payment-receive-detail-drawer',
  PAYMENT_MADE_DETAILS = 'payment-made-drawer',
  ESTIMATE_DETAILS = 'estimate-detail-drawer',
  PURCHASE_ORDER_DETAILS = 'purchase-order-detail-drawer',
  GOODS_RECEIPT_DETAILS = 'goods-receipt-detail-drawer',
  DELIVERY_NOTE_DETAILS = 'delivery-note-detail-drawer',
  BILL_OF_MATERIALS_DETAILS = 'bill-of-materials-detail-drawer',
  MANUFACTURING_ORDER_DETAILS = 'manufacturing-order-detail-drawer',
  ITEM_DETAILS = 'item-detail-drawer',
  CUSTOMER_DETAILS = 'customer-detail-drawer',
  VENDOR_DETAILS = 'vendor-detail-drawer',
  INVENTORY_ADJUSTMENT_DETAILS = 'inventory-adjustment-drawer',
  CASHFLOW_TRNASACTION_DETAILS = 'cashflow-transaction-drawer',
  QUICK_CREATE_CUSTOMER = 'quick-create-customer',
  QUICK_CREATE_ITEM = 'quick-create-item',
  QUICK_WRITE_VENDOR = 'quick-write-vendor',
  QUICK_CREATE_EMPLOYEE = 'quick-create-employee',
  QUICK_CREATE_INVOICE = 'quick-create-invoice',
  QUICK_CREATE_BILL = 'quick-create-bill',
  QUICK_IMPORT_DOCUMENT = 'quick-import-document',
  CREDIT_NOTE_DETAILS = 'credit-note-detail-drawer',
  VENDOR_CREDIT_DETAILS = 'vendor-credit-detail-drawer',
  REFUND_CREDIT_NOTE_DETAILS = 'refund-credit-detail-drawer',
  REFUND_VENDOR_CREDIT_DETAILS = 'refund-vendor-detail-drawer',
  WAREHOUSE_TRANSFER_DETAILS = 'warehouse-transfer-detail-drawer',
  TAX_RATE_DETAILS = 'tax-rate-detail-drawer',
  CATEGORIZE_TRANSACTION = 'categorize-transaction',
  CHANGE_SUBSCARIPTION_PLAN = 'change-subscription-plan',
  INVOICE_CUSTOMIZE = 'INVOICE_CUSTOMIZE',
  ESTIMATE_CUSTOMIZE = 'ESTIMATE_CUSTOMIZE',
  PAYMENT_RECEIPT_CUSTOMIZE = 'PAYMENT_RECEIPT_CUSTOMIZE',
  RECEIPT_CUSTOMIZE = 'RECEIPT_CUSTOMIZE',
  CREDIT_NOTE_CUSTOMIZE = 'CREDIT_NOTE_CUSTOMIZE',
  PAYMENT_RECEIVED_CUSTOMIZE = 'PAYMENT_RECEIVED_CUSTOMIZE',
  BUSINESS_PLAN_CUSTOMIZE = 'BUSINESS_PLAN_CUSTOMIZE',
  BRANDING_TEMPLATES = 'BRANDING_TEMPLATES',
  PAYMENT_INVOICE_PREVIEW = 'PAYMENT_INVOICE_PREVIEW',
  STRIPE_PAYMENT_INTEGRATION_EDIT = 'STRIPE_PAYMENT_INTEGRATION_EDIT',
  INVOICE_SEND_MAIL = 'INVOICE_SEND_MAIL',
  ESTIMATE_SEND_MAIL = 'ESTIMATE_SEND_MAIL',
  RECEIPT_SEND_MAIL = 'RECEIPT_SEND_MAIL',
  PAYMENT_RECEIVED_SEND_MAIL = 'PAYMENT_RECEIVED_SEND_MAIL',
  ENTITY_EDIT = 'entity-edit-drawer',
  GUIDE = 'guide-drawer',
}
